import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
    return (
        <div className="max-w-[600px] mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
            <h1 className="font-serif text-4xl">No gift processed.</h1>
            <p className="text-[var(--rl-text-2)] mt-3">You cancelled the checkout. The dogs are still waiting — every dollar helps.</p>
            <div className="mt-8 flex justify-center gap-3">
                <Link to="/donate"><Button className="btn-primary rounded-full h-11 px-5" data-testid="try-again-btn">Try again</Button></Link>
                <Link to="/"><Button variant="outline" className="rounded-full h-11 px-5">Back home</Button></Link>
            </div>
        </div>
    );
}
